import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const shutdownAlisaIvrCompanyKey = (shutdownId) => [
  'shutdownAlisaIvrCompanyKey',
  shutdownId,
];

const shutdownAlisaIvrCompanyQuery = async ({ queryKey }) => {
  const [_, shutdownId] = queryKey;

  return await request.get(
    `/Alert/is_ivr_for_service_company/${shutdownId}`,
    {},
    `При определении IVR по УК произошла ошибка`
  );
};

export const useShutdownAlisaIvrCompany = (shutdownId, options) =>
  useQuery(
    shutdownAlisaIvrCompanyKey(shutdownId),
    shutdownAlisaIvrCompanyQuery,
    options
  );
